import {AfterContentInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {combineLatest, Observable, of, Subscription}                                  from 'rxjs';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  LanguageStore
}                                                                                     from '../../stores/translation/language.store';
import {filter, map}                                                                  from 'rxjs/operators';
import {
  ApDynGridStatusColumnConfig
}                                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridEditColumnConfig
}                                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  SettingsStore
}                                                                                     from '../../stores/base-data/settings.store';
import {
  ApDynGridPagerConfig,
  IDynGridWizardChoiceData,
  IGridPagerSubmitData
}                                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {ApGridPagerType, IWizardProperties}                                           from '../../ap-interface';
import {
  ApUtilService
} from '../../ap-utils/service/ap-util.service';
import {
  ApIcons
} from '../../ap-interface/enums/layout/ap-icons';
import {
  ApDynComponentComponent
} from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDateService
}                                                                                     from '../../ap-core/services/ap-date-service';
import {
  TranslationStore
}                                                                                     from '../../stores/translation/translation.store';
import {
  FormStore
}                                                                                     from '../../stores/layout/form.store';
import {
  TaskManagementWizardComponent
}                                                                                     from './wizard/task-management-wizard.component';
import {
  TaskManagementStore
}                                                                                     from '../../stores/task-management/task-management.store';
import {
  TaskManagementDataProviders
}                                                                                     from '../task-management-data-providers/task-management-data-providers';
import {MapStore}                                                                     from '../../stores/map/map.store';
import {
  CampaignYearStore
}                                                                                     from '../../stores/login/campaignyear.store';
import {
  FieldStore
}                                                                                     from '../../stores/farm/field.store';
import {
  IRouterStateUrl,
  RouterStore
}                                                                                     from '../../stores/router/router.store';
import {GetRoundNumericPipe}                                                          from '../../ap-utils';
import {
  UserContactsStore
}                                                                                     from '../../stores/base-data/user.contacts.store';
import {
  TerminalsStore
}                                                                                     from '../../stores/base-data/terminals.store';
import {
  ApDynGridGroupColumnConfig
}                                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  ApLegendScrollerService
}                                                                                     from '../../map/components/layer-controller/ap-legend-scroller.service';
import {
  ApTooltipContentService
}                                                                                     from '../../ap-utils/service/ap-tooltip-content.service';
import {
  LEGEND_IDS
}                                                                                     from '../../ap-interface/enums/ap-legend-ids.enum';
import {
  TaskManagementEditComponent
}                                                                                     from './editing/task-management-edit.component';
import {
  GetApplicationModeService
}                                                                                     from '../../ap-utils/service/ap-get-applicationmode.service';
import {
  ITaskManagementPlanSummaryGridData,
  TaskManagementAction,
  TaskManagementWizardOpenConfig,
  TaskManagementWizardOpenConfigType
}                                                                                     from '../task-management.types';
import {
  ISelectionChangeEvent
}                                                                                     from '../../map/components/layer-controller/ap-legend-scroller-item.component';
import {
  WorkTypes
}                                                                                     from '../../stores/base-data/worrktypes.store';
import {
  FieldArchiveStore
}                                                                                     from '../../stores/farm/field-archive.store';
import {
  GetRoundNumericPipeConfig
}                                                                                     from '../../ap-utils/pipes/configs/get-round-numeric.pipe.config';
import {
  IGridStatus
}                                                                                     from '../../ap-interface/interfaces/ap-grid-status.interface';
import {
  nameOf
}                                                                                     from '../../ap-core/utils/ap-name-of';
import ITaskManagementPlanSummary = Data.TaskManagement.ITaskManagementPlanSummary;
import TaskManagementModule = Data.TaskManagement.TaskManagementModule;

@Component({
  selector: 'task-management-overview',
  template: `
    <ap-dyncomponent [caption]="'Admin_Pages__Overview'"
                     [headerIcon]="'ap-icon-tasks'"
                     [filterTooltip]="''"
                     [canSearch]="true"
                     [canCreate]="false"
                     [columns]="columns$ | async"
                     [items]="items$ | async"
                     [loading$]="loading$"
                     [selectable]="{checkboxOnly: false, mode: 'single', enabled: true}"
                     [pager]="pager">
    </ap-dyncomponent>
  `
})
export class TaskManagementOverviewComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public columns$: Observable<ApDynGridColumnConfigBase[]> = of([]);
  public items$: Observable<ITaskManagementPlanSummaryGridData[]>;
  public loading$: Observable<boolean>;
  public pager: ApDynGridPagerConfigBase;

  private _crossComponentCallData: IRouterStateUrl = undefined;
  private _wizardOpened = false;
  private _subscriptions: Subscription[] = [];

  constructor(private taskManagementStore: TaskManagementStore,
              private languageStore: LanguageStore,
              private fieldStore: FieldStore,
              private translationStore: TranslationStore,
              private settingsStore: SettingsStore,
              private dateService: ApDateService,
              private formStore: FormStore,
              private mapStore: MapStore,
              private roundNumericPipe: GetRoundNumericPipe,
              private campaignYearStore: CampaignYearStore,
              private dataProviders: TaskManagementDataProviders,
              private changeDetection: ChangeDetectorRef,
              private routerStore: RouterStore,
              private userContactsStore: UserContactsStore,
              private legendScrollerService: ApLegendScrollerService,
              private terminalsStore: TerminalsStore,
              private tooltipService: ApTooltipContentService,
              private fieldArchiveStore: FieldArchiveStore,
              private applicationModeService: GetApplicationModeService) {
  }

  public ngOnInit(): void {
    this.loading$ = combineLatest([
      this.taskManagementStore.Listen(s => s.loading),
      this.campaignYearStore.Listen(c => c.loading),
      this.userContactsStore.Listen(c => c.loading),
      this.terminalsStore.Listen(c => c.loading),
      this.fieldStore.Listen(f => f.loading)]
    ).pipe(
      map(items => items.some(x => x))
    );
    this.pager = this._getPager();
    this.columns$ = this._getColumns();
    this.items$ = this._getItems();
  }

  public ngAfterContentInit(): void {
    this._subscriptions.push(combineLatest([
      this.routerStore.Listen(s => s),
      this.campaignYearStore.Listen(s => s.selectedYear)
    ]).subscribe(([routerStoreData, _]) => {
      this._onRouterServiceOrSelectedYearChanged(routerStoreData);
    }));
    this._subscriptions.push(this.formStore.FormClose$.subscribe(() => {
      // force detect changes in case wizard closes - ignore all kind of other forms.
      // do not reload if it was a navigation from another component
      this._onFormClose();
    }));
    this._subscriptions.push(this.legendScrollerService.selectionChange.subscribe((event: ISelectionChangeEvent): void => {
      this._onScrollerLegendServiceSelectionChange(event);
    }));
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe(_ => this._selectionChange()));
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  private _getItems(): Observable<ITaskManagementPlanSummaryGridData[]> {
    return combineLatest([
      this.taskManagementStore.Listen(d => d.data),
      this.campaignYearStore.Listen(s => s.selectedYear),
      this.fieldStore.Listen(f => f.data),
      this.fieldArchiveStore.Listen(s => s.loaded)
    ]).pipe(
      filter(([taskManagement, campaignYear, fields, fieldArchiveLoaded]) =>
        taskManagement && campaignYear && fields && fields?.length > 0 && fieldArchiveLoaded),
      map(([taskManagement]) => taskManagement.map<ITaskManagementPlanSummaryGridData>(planSummary => {
        const userApplRate = this.dataProviders[planSummary.Module].getApplRate(planSummary);
        const result: ITaskManagementPlanSummaryGridData = {
          Id: planSummary.Id,
          SourceItem: planSummary,
          Status: this.getSummaryStatus(planSummary),
          Module: planSummary.Module,
          Note: planSummary.Remark,
          UserApplRate: userApplRate,
          ProductUnitPerHa: !!userApplRate ? this.dataProviders[planSummary.Module].getProductUnit(planSummary, true) : '',
          UserApplSum: this.dataProviders[planSummary.Module].getApplSum(planSummary),
          ProductUnit: this.dataProviders[planSummary.Module].getProductUnit(planSummary, false),
          FieldsTooltip: this.tooltipService.getFieldsCropsTooltip(planSummary.PlanBooks),
          ApplDate: this.dateService.getDateMidnight(this.dataProviders[planSummary.Module].getDate(planSummary.ApplDate)),
          ApplicationModeText: this.dataProviders[planSummary.Module].getApplicationModeText(planSummary),
          ModuleText: this.dataProviders[planSummary.Module].getModuleText(planSummary),
          OperationModeText: this.dataProviders[planSummary.Module].getOperationModeText(planSummary),
          ElementName: this.dataProviders[planSummary.Module].getElementName(planSummary),
          ProductName: this.dataProviders[planSummary.Module].getProductName(planSummary),
          AreaHaSum: this.dataProviders[planSummary.Module].getAreaHaSum(planSummary),
          ApplUnitPerHa: this.dataProviders[planSummary.Module].getApplUnit(planSummary, true),
          AlreadyExported: this.dataProviders[planSummary.Module].getAlreadyExported(planSummary)
        };
        return result;
      }))
    );
  }

  private _getPager(): ApDynGridPagerConfigBase {
    return new ApDynGridPagerConfig({
      preselect: false,
      listMassEditing: this._getActions(),
      iconButtons: [
        {
          icon: ApIcons.PDF,
          callback: ApUtilService.createEventEmitter(this._onPdf.bind(this), this._subscriptions),
          tooltip: 'Global__Save_PDF'
        },
        {
          icon: ApIcons.XLS,
          callback: ApUtilService.createEventEmitter(this._onXlsPrint.bind(this), this._subscriptions),
          tooltip: 'Global__Save_EXCEL'
        }
      ]
    });
  }

  private _getColumns(): Observable<ApDynGridColumnConfigBase[]> {
    return combineLatest([
      this.languageStore.Listen(s => s.selectedLanguage),
      this.settingsStore.Listen(s => s.data)
    ]).pipe(
      filter(([language, settings]) => !!language && settings.length !== 0),
      map(([language, settings]) => ({language, setting: settings[0]})),
      map((p) => {
        return [
          new ApDynGridStatusColumnConfig({
            field: `${nameOf<ITaskManagementPlanSummaryGridData>('Status')}.${nameOf<IGridStatus>('state')}`,
            class: `${nameOf<ITaskManagementPlanSummaryGridData>('Status')}.${nameOf<IGridStatus>('class')}`,
            description: `${nameOf<ITaskManagementPlanSummaryGridData>('Status')}.${nameOf<IGridStatus>('description')}`,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Nutrients__FertilizationDate',
            field: nameOf<ITaskManagementPlanSummaryGridData>('ApplDate'),
            headerFilterable: true,
            format: p.language.DateFormat,
            tooltip: (dataItem) => this.dataProviders[dataItem?.Module].getPlanNumberTooltip(dataItem),
            hide: new ApDynGridColumnHideConfig({
              mapHide: true
            }),
            width: 160,
            sortIndex: 1,
            sortDesc: true,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Module',
            field: nameOf<ITaskManagementPlanSummaryGridData>('ModuleText'),
            headerFilterable: true,
            width: 80,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__OperationMode',
            field: nameOf<ITaskManagementPlanSummaryGridData>('OperationModeText'),
            headerFilterable: true,
            width: 130,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'AgriConnect__Nutrient',
            field: nameOf<ITaskManagementPlanSummaryGridData>('ElementName'),
            headerFilterable: true,
            width: 120,
            filterable: true,
            hide: new ApDynGridColumnHideConfig({
              mapHide: true
            })
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Product',
            field: nameOf<ITaskManagementPlanSummaryGridData>('ProductName'),
            headerFilterable: true,
            width: 180,
            multiline: true,
            filterable: true,
            tooltip: (dataItem: any) => dataItem['ProductTooltip']
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global_ha_Unit',
            field: nameOf<ITaskManagementPlanSummaryGridData>('AreaHaSum'),
            tooltip: (dataItem) => dataItem?.AreaHaSum,
            hide: new ApDynGridColumnHideConfig({
              mapHide: true
            }),
            width: 70,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [p.setting.DigitsAfterDecimalPoint]
            }],
            filterable: true
          }),
          new ApDynGridGroupColumnConfig({
            title: `${this.translationStore.FindTranslationForSelectedLanguage('Nutrients__Average_Amount_Goods')} / ` +
              `${this.translationStore.FindTranslationForSelectedLanguage('Global__Remaining_Need_Two_Short')}`,
            headerStyle: {'text-align': 'center'},
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                field: nameOf<ITaskManagementPlanSummaryGridData>('UserApplRate'),
                width: 80,
                cssClass: 'right',
                filterType: FilterType.NUMBER,
                tooltip: (dataItem) => dataItem?.UserApplRate,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [0, GetRoundNumericPipeConfig.NullAndZeroToEmptyReplaceConfig]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                field: nameOf<ITaskManagementPlanSummaryGridData>('ProductUnitPerHa'),
                width: 60
              })
            ]
          }),
          new ApDynGridGroupColumnConfig({
            title: `${this.translationStore.FindTranslationForSelectedLanguage('Global__Sum')} ` +
              `${this.translationStore.FindTranslationForSelectedLanguage('Product')}`,
            headerStyle: {'text-align': 'center'},
            hide: new ApDynGridColumnHideConfig({
              mapHide: true
            }),
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                field: nameOf<ITaskManagementPlanSummaryGridData>('UserApplSum'),
                tooltip: (dataItem) => Number.isFinite(dataItem?.UserApplSum) ? `${dataItem?.UserApplSum} ${dataItem?.ProductUnit}` : undefined,
                hide: new ApDynGridColumnHideConfig({
                  mapHide: true
                }),
                width: 80,
                cssClass: 'right',
                filterType: FilterType.NUMBER,
                pipes: [{
                  pipe: this.roundNumericPipe,
                  args: [p.setting.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
                }]
              }),
              new ApDynGridPropertyColumnConfig({
                field: nameOf<ITaskManagementPlanSummaryGridData>('ProductUnit'),
                hide: new ApDynGridColumnHideConfig({
                  mapHide: true
                }),
                width: 60,
                filterable: true
              })
            ]
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Base__Fields',
            field: nameOf<ITaskManagementPlanSummaryGridData>('AlreadyExported'),
            hide: new ApDynGridColumnHideConfig({
              mapHide: true
            }),
            headerExtraLines: ['Task_Mgmt_Already_Exported'],
            tooltip: (dataItem: ITaskManagementPlanSummaryGridData) => dataItem?.FieldsTooltip,
            width: 120,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Note',
            field: nameOf<ITaskManagementPlanSummaryGridData>('Note'),
            width: 120,
            filterable: true,
            headerFilterable: true,
          }),
          new ApDynGridEditColumnConfig({
            data: this._getActions().map(a => ({
              text: a.name,
              callback: a.onSubmit,
              disabled: a.id === 0 ? this._exportDisabledSingleEdit : a.id === 2 ? this._bookDisabledSingleEdit : undefined
            })),
            disabled: false
          })
        ];
      })
    );
  }

  private _getActions(): IDynGridWizardChoiceData[] {
    return [
      {
        id: 0,
        name: 'Task_Mgmt_Export',
        type: ApGridPagerType.None,
        values: [],
        onSubmit: ApUtilService.createEventEmitter(this._onExportClicked.bind(this), this._subscriptions),
        disabled: this._exportDisabledMassEdit
      },
      {
        id: 1,
        name: 'Global__Show',
        type: ApGridPagerType.None,
        values: [],
        onSubmit: ApUtilService.createEventEmitter(this._onShowClicked.bind(this), this._subscriptions)
      },
      {
        id: 2,
        name: 'Admin_Pages_Popups__Book',
        type: ApGridPagerType.None,
        values: [],
        onSubmit: ApUtilService.createEventEmitter(this._onBookClicked.bind(this), this._subscriptions),
        disabled: this._bookDisabledMassEdit
      }
    ];
  }

  private _selectionChange(): void {
    if (!this.dynComponent || !this.dynComponent.dynGrid || !this.dynComponent.dynGrid.gridPaging) {
      return;
    }
    const selectedSummaries = this.dynComponent.dynGrid.gridPaging.selectedItems as ITaskManagementPlanSummaryGridData[];
    if (selectedSummaries && selectedSummaries.length > 0 && selectedSummaries[0].SourceItem?.PlanBooks != null) {
      const selectedPlans = selectedSummaries[0].SourceItem.PlanBooks;
      this.mapStore.Layers.TaskManagementLayer.replaceSource(selectedPlans, this.fieldStore);
      this.mapStore.Layers.TaskManagementLayer.ZoomIn(500);
      const dataProvider = this.dataProviders[selectedSummaries[0].SourceItem.Module];
      const mapUrl = dataProvider?.getMapFactoryUrl(selectedPlans);
      if (mapUrl?.length > 0) {
        const legend = dataProvider?.getMapLegend(selectedSummaries[0].SourceItem)();
        this.mapStore.Legends.TaskMgmtLegend = legend;
        this.mapStore.Legends.refreshLegend(legend, true);
        this.mapStore.Layers.TaskManagementNutrientLayer.Legend = () => legend;
        this.mapStore.Layers.TaskManagementNutrientLayer.Tooltip = dataProvider?.getMapLayerTooltip();
        this.mapStore.Layers.TaskManagementNutrientLayer.update(mapUrl);
      } else {
        this.mapStore.Layers.TaskManagementNutrientLayer.clear();
      }
      setTimeout(() => dataProvider?.selectLegendItem(selectedSummaries[0].SourceItem), 0);
    } else {
      this.mapStore.Layers.TaskManagementLayer.clear();
      this.mapStore.Layers.TaskManagementNutrientLayer.clear();
      this.fieldStore.zoomFarmFields();
    }
  }

  private _onRouterServiceOrSelectedYearChanged(routerStoreData: IRouterStateUrl): void {
    this.userContactsStore.loadUserContacts();
    this.terminalsStore.loadTerminals();
    // load only id which was passed:
    if (!routerStoreData.url?.startsWith('/task-management/overview')) {
      return;
    }
    if (routerStoreData.queryParams['id'] !== undefined && !this._crossComponentCallData) {
      this._crossComponentCallData = routerStoreData;
      const showBookings = routerStoreData.queryParams['bookings'] !== undefined;
      this.taskManagementStore.loadTaskManagementPlanSummaries(routerStoreData.queryParams['id'], showBookings);
      this._subscriptions.push(this.items$.subscribe(items => {
        // Whenever items are done with loading we might do some magic in case it was cross component call
        if (!this._crossComponentCallData || this._wizardOpened) {
          return;
        }
        const targetItem = items?.Find(d => d.Id === this._crossComponentCallData.queryParams['id']);
        if (!targetItem) {
          return;
        }
        this._wizardOpened = true;
        const showOnly = this._crossComponentCallData.queryParams['show'] !== undefined;
        setTimeout(() => {
          const componentToRedirect = showOnly ? TaskManagementEditComponent : TaskManagementWizardComponent;
          const dataObject = {PlanSummary: targetItem, RouterData: this._crossComponentCallData};
          if (!showOnly) {
            dataObject['Type'] = TaskManagementWizardOpenConfigType.Export;
          }
          this.formStore.openForm({
            component: componentToRedirect,
            data: dataObject
          });
          if (this._crossComponentCallData.queryParams['url']) {
            this._subscriptions.push(this.formStore.FormClose$.subscribe(() => {
              this.routerStore.navigate([this._crossComponentCallData.queryParams['url']]).then();
            }));
          }
        }, 0);
      }));
    } else {
      this.taskManagementStore.loadTaskManagementPlanSummaries();
    }
  }

  private _onFormClose(): void {
    const updatedComponent = this.formStore.Listen(s => s.updateComponent).getValue();
    if (!this._crossComponentCallData && updatedComponent && updatedComponent.data &&
      (updatedComponent.data?.PlanSummary?.SourceItem as ITaskManagementPlanSummary)?.PlanNumber && this._wizardOpened) {
      this._wizardOpened = false;
      this.changeDetection.detectChanges();
      this.taskManagementStore.loadTaskManagementPlanSummaries();
    }
  }

  private _onScrollerLegendServiceSelectionChange(event: ISelectionChangeEvent): void {
    if (event.legend?.id !== LEGEND_IDS.TASK_MANAGEMENT || !event.selectionKeys || event.selectionKeys.length < 1) {
      return;
    }
    const selectedSummaries = this.dynComponent?.dynGrid?.gridPaging?.selectedItems as ITaskManagementPlanSummaryGridData[];
    if (!selectedSummaries || selectedSummaries?.length < 1) {
      return;
    }
    const selectedPlans = selectedSummaries[0].SourceItem.PlanBooks;
    if (!selectedPlans || selectedPlans?.length < 1) {
      return;
    }
    const dataProvider = this.dataProviders[selectedSummaries[0].SourceItem.Module];
    const mapUrl = dataProvider?.getMapFactoryUrl(selectedPlans, event.selectionKeys[0].toLowerCase());
    this.mapStore.Layers.TaskManagementNutrientLayer.update(mapUrl);
  }

  private getSummaryStatus(summary: ITaskManagementPlanSummary): IGridStatus {
    const applicationModeText = this.dataProviders[summary.Module].getApplicationModeText(summary);
    return {
      state: this.applicationModeService.GetApplicationModeStatus(summary?.ApplicationMode)?.state,
      class: this.applicationModeService.GetApplicationModeStatus(summary?.ApplicationMode)?.class,
      description: applicationModeText
    };
  }

  private _onExportClicked(item: any | IGridPagerSubmitData): void {
    const pagerItems = item as IGridPagerSubmitData;
    if (pagerItems && pagerItems.items) {
      item = pagerItems.items[0];
    }
    if (!item) {
      return;
    }
    const wizardOpenConfig = new TaskManagementWizardOpenConfig();
    wizardOpenConfig.PlanSummary = item;
    wizardOpenConfig.Type = TaskManagementWizardOpenConfigType.Export;

    // The user might not have selected the row, but using the button to export
    // Without selecting the row we will get an 'ExpressionHasBeenChangedAfter...' exception
    this.dynComponent.dynGrid.gridPaging.setSelectedKeys([item.Id]);
    this._wizardOpened = true;
    this.formStore.openForm({component: TaskManagementWizardComponent, data: wizardOpenConfig});
  }

  private _onShowClicked(item: any | IGridPagerSubmitData): void {
    const pagerItems = item as IGridPagerSubmitData;
    if (pagerItems && pagerItems.items) {
      item = pagerItems.items[0];
    }
    if (!item) {
      return;
    }

    // The user might not have selected the row, but using the button to export
    // Without selecting the row we will get an 'ExpressionHasBeenChangedAfter...' exception
    this.dynComponent.dynGrid.gridPaging.setSelectedKeys([item.Id]);
    this._wizardOpened = true;
    this.formStore.openForm({
      component: TaskManagementEditComponent,
      data: {PlanSummary: item, RouterData: this._crossComponentCallData}
    });
  }

  private _onBookClicked(item: any | IGridPagerSubmitData): void {
    this._navigateToEditBookModule(item, TaskManagementAction.Booking);
  }

  private _navigateToEditBookModule(item: any | IGridPagerSubmitData, action: TaskManagementAction): void {
    const pagerItems = item as IGridPagerSubmitData;
    if (pagerItems && pagerItems.items) {
      item = pagerItems.items[0];
    }
    if (!item) {
      return;
    }
    this.routerStore.navigate([this.dataProviders[item?.SourceItem.Module].getComponentUrl()], {
      id: item.Id,
      action,
      url: 'task-management/overview'
    }).then();
  }

  private _exportDisabledMassEdit = (item: IWizardProperties) => {
    const module = item?.selectedItems?.FirstOrDefault()?.Module;
    if (module !== TaskManagementModule.PS_Fertilization) {
      return false;
    }
    const summary = item?.selectedItems?.FirstOrDefault()?.SourceItem;
    return summary?.PlanBooks?.FirstOrDefault()?.PpProductList?.FirstOrDefault()?.ProductListDetails?.WorkType !== WorkTypes.Spraying;
  }

  private _exportDisabledSingleEdit = (item: ITaskManagementPlanSummaryGridData) => {
    const module = item?.Module;
    if (module !== TaskManagementModule.PS_Fertilization) {
      return false;
    }
    const summary = item?.SourceItem;
    return summary?.PlanBooks?.FirstOrDefault()?.PpProductList?.FirstOrDefault()?.ProductListDetails?.WorkType !== WorkTypes.Spraying;
  }

  private _bookDisabledMassEdit = (item: IWizardProperties) => {
    const module = item?.selectedItems?.FirstOrDefault()?.Module;
    return module === TaskManagementModule.N_NFertilization || module === TaskManagementModule.PS_Fertilization;
  }

  private _bookDisabledSingleEdit = (item: ITaskManagementPlanSummaryGridData) => {
    const module = item?.Module;
    return module === TaskManagementModule.N_NFertilization || module === TaskManagementModule.PS_Fertilization;
  }

  private _onXlsPrint(): void {
    this.dynComponent.dynGrid.xlsExportFileName = this._generatePrintFilename();
    this.dynComponent.dynGrid.exportAsXls();
  }

  private _onPdf(): void {
    this.dynComponent.dynGrid.pdfExportFileName = this._generatePrintFilename();
    this.dynComponent.dynGrid.exportAsPdf();
  }

  private _generatePrintFilename(): string {
    return this.dateService.toFarmDate(new Date()).format('YYMMDD') + '_' +
      this.translationStore.FindTranslationForSelectedLanguage('AgriConnect__Taskmanagement');
  }
}
